// #region Imports
// Librerías externas
import React, { useEffect, useMemo, useState } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import classnames from "classnames"
import { Link } from "react-router-dom"
import InputMask from "react-input-mask"
import { ToastContainer, toast } from "react-toastify"
import Flatpickr from "react-flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import FormikInput from "../Common/Formik/FormikInput"
import FormikAsyncSelect from "../Common/Formik/FormikAsyncSelect"
import PropTypes from "prop-types"
import TableContainer from "../../components/Common/TableContainer"
import "flatpickr/dist/themes/material_blue.css"
import "react-toastify/dist/ReactToastify.css"
import "react-datepicker/dist/react-datepicker.css"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"

//redux
import { useDispatch } from "react-redux"

// Componentes internos
import Breadcrumbs from "./Breadcrumb"
import { AltaAlumnoSchema } from "../../utils/validationSchemas"

// Reactstrap
import {
  Badge,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  UncontrolledAlert,
  UncontrolledTooltip,
} from "reactstrap"

// Selectors
import { useContribuyentesLista } from "store/selectors"
// #endregion

// #region actions
import { getContribuyentesLista } from "../../store/actions"
// #endregion

const hoy = new Date()
const primerDiaMes = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  1
)

const ContribuyentesComponent = () => {
  // Const

  // #region const-selectors
  const listaContribuyentes = useContribuyentesLista()
  // #endregion

  // #region Internal States
  // Estados para manejar tabs y pasos completados
  const [contribuyentes, setContribuyentes] = useState([])
  // #endregion

  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region Functions

  // #endregion

  // #region useEffects
  useEffect(() => {
    if (contribuyentes && contribuyentes.length === 0) {
      dispatch(
        getContribuyentesLista({
          nombreSolicitud: "listacontribuyentes",
        })
      )
    }
  }, [])

  useEffect(() => {
    if (listaContribuyentes && listaContribuyentes.length > 0) {
      setContribuyentes(listaContribuyentes)
    }
  }, [listaContribuyentes, dispatch])

  // #endregion

  //#region Formik form
  // Definición de initialValues y validationSchema

  const columns = useMemo(
    () => [
      // {
      //   header: "id",
      //   accessorKey: "id_Contribuyente",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   size: 20,
      //   cell: cellProps => {
      //     return (
      //       <Link to="#" className="text-body fw-bold">
      //         {cellProps.row.original.id_Contribuyente}
      //       </Link>
      //     )
      //   },
      // },
      {
        header: "RFC",
        accessorKey: "RFC",
        enableColumnFilter: false,
        enableSorting: true,
        size: 15,
      },
      {
        header: "Razón Social",
        accessorKey: "Razon_Social",
        enableColumnFilter: false,
        enableSorting: true,
        size: 100,
      },
      {
        header: "CP",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "oDireccion.Codigo_Postal",
        size: 15,
      },
      {
        header: "Régimen Fiscal",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "Regimen_Fiscal",
        size: 50,
      },
      {
        header: "Status",
        accessorKey: "Borrado",
        enableColumnFilter: false,
        enableSorting: true,
        size: 20,
        cell: cellProps => {
          switch (cellProps.row.original.Borrado) {
            case false:
              return <Badge className="bg-success">Activo</Badge>
            case true:
              return <Badge className="bg-danger">Borrado</Badge>
          }
        },
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        size: 50,
        cell: cellProps => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link
                  to="#"
                  onClick={() => {
                    // console.log(cellProps.row.original)
                    // setoAlumno(cellProps.row.original)
                    // setModal(true)
                    // setIsEdit(false)
                  }}
                  className="btn btn-sm btn-soft-primary"
                  id={`viewtooltip-${cellProps.row.original.id_Contribuyente}`}
                >
                  <i className="mdi mdi-eye-outline" />
                </Link>
              </li>
              <UncontrolledTooltip
                placement="top"
                target={`viewtooltip-${cellProps.row.original.id_Contribuyente}`}
              >
                Detalles
              </UncontrolledTooltip>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={() => {
                    //console.log(cellProps.row.original)
                    // setoAlumno(cellProps.row.original)
                    // setModal(true)
                    // setIsEdit(true)
                  }}
                  id={`edittooltip-${cellProps.row.original.id_Contribuyente}`}
                >
                  <i className="mdi mdi-pencil-outline" />
                  <UncontrolledTooltip
                    placement="top"
                    target={`edittooltip-${cellProps.row.original.id_Contribuyente}`}
                  >
                    Editar
                  </UncontrolledTooltip>
                </Link>
              </li>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={() => {
                    // const jobData = cellProps.row.original
                    // onClickDelete(jobData)
                  }}
                  id={`deletetooltip-${cellProps.row.original.id_Contribuyente}`}
                >
                  <i className="mdi mdi-delete-outline" />
                  <UncontrolledTooltip
                    placement="top"
                    target={`deletetooltip-${cellProps.row.original.id_Contribuyente}`}
                  >
                    Baja
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          )
        },
      },
    ],
    []
  )
  // #endregion

  return (
    <React.Fragment>
      <TableContainer
        columns={columns}
        data={contribuyentes || []}
        isCustomPageSize={false}
        isGlobalFilter={true}
        // divClassName="container"
        isAddButton={true}
        buttonClass="btn btn-primary btn-rounded waves-effect waves-light mb-2 me-2 addOrder-modal"
        buttonName=" Add New Order"
        //handleUserClick={handleStatusFilterSelection}
        isJobListGlobalFilter={true}
        statusOptions={[]}
        isPagination={true}
        SearchPlaceholder="Búsqueda ..."
        tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
        theadClass="table-light"
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
        //selectedValue={sListaIdStatus ? sListaIdStatus : "1,4"}
      />
    </React.Fragment>
  )
}

export default ContribuyentesComponent
